import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { NzSelectModule } from 'ng-zorro-antd/select';
import { CloseDropdownOnScrollModule } from '../../directives/close-dropdown-on-scroll/close-dropdown-on-scroll.module';
import { NzIconModule } from 'ng-zorro-antd/icon';

import { SelectMultiAntdControlComponent } from './select-multi-antd-control.component';

@NgModule({
  declarations: [SelectMultiAntdControlComponent],
  exports: [SelectMultiAntdControlComponent],
  imports: [
    CommonModule,
    NzSelectModule,
    CloseDropdownOnScrollModule,
    FormsModule,
    NzIconModule,
    ReactiveFormsModule,
  ]
})
export class SelectMultiAntdControlModule { }
